import styled from 'styled-components';
import { mixins } from '../../../themes';

export const InputList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    ${mixins.gap(1)}
`;
